export const routes = {
    blank: '/blank',
    index: '/',
    definitions: '/definitions',
    firstPreface: '/firstpreface',
    revisedPreface: '/revisedpreface',
    websitePreface: '/websitepreface',
    copyright: '/copyright'
}